import { LimeInput } from "@/Components/NextBase/LimeInput";
import { LimeTextarea } from "@/Components/NextBase/LimeTextarea";
import { api } from "@/lib/api-client";
import { PutClientForm } from "@/server-types";
import { Button, Spinner } from "@heroui/react";
import { Trash } from "lucide-react";

export type AccordionsProps = {
  accordions: PutClientForm["body"]["accordions"];
  setAccordions: (accordions: PutClientForm["body"]["accordions"]) => void;
};

export const Accordions = ({ accordions, setAccordions }: AccordionsProps) => {
  if (!accordions) return null;

  const addAccordion = () => {
    setAccordions([
      ...accordions,
      {
        accordionsLocalized: [],
      },
    ]);
  };

  return (
    <>
      {accordions.map((accordion, index) => {
        return (
          <RenderAccordion
            key={index}
            index={index}
            setAccordions={setAccordions}
            accordions={accordions}
          />
        );
      })}

      <Button onPress={addAccordion}>Dodaj</Button>
    </>
  );
};

const RenderAccordion = ({
  index,
  setAccordions,
  accordions,
}: {
  index: number;
  setAccordions: (accordions: PutClientForm["body"]["accordions"]) => void;
  accordions: NonNullable<PutClientForm["body"]["accordions"]>;
}) => {
  const { data: languages, isFetching: isFetchingLanguages } =
    api.values.useGetLanguages();

  if (isFetchingLanguages) return <Spinner />;
  if (!languages) return <p>Failed to load languages</p>;

  return (
    <div className="my-4 rounded-lg bg-gray-100 p-2">
      <Button
        isIconOnly
        onPress={() => setAccordions(accordions?.filter((_, i) => i !== index))}
      >
        <Trash />
      </Button>

      {languages?.map((language) => {
        const accordion = accordions?.[index]?.accordionsLocalized.find(
          (accordion) => accordion.language === language,
        );

        return (
          <div key={language}>
            <p>{language}</p>
            <LimeInput
              label={"title"}
              value={accordion?.title || ""}
              variant="bordered"
              onValueChange={(val) => {
                const updatedAccordions = [...accordions];
                if (
                  !updatedAccordions[index].accordionsLocalized.find(
                    (a) => a.language === language,
                  )
                ) {
                  updatedAccordions[index].accordionsLocalized.push({
                    language,
                    title: val,
                    body: "",
                  });
                } else {
                  updatedAccordions[index].accordionsLocalized =
                    updatedAccordions[index].accordionsLocalized.map(
                      (accordion) => {
                        if (accordion.language === language) {
                          return { ...accordion, title: val };
                        }
                        return accordion;
                      },
                    );
                }
                setAccordions(updatedAccordions);
              }}
            />
            <LimeTextarea
              label={"body"}
              value={accordion?.body || ""}
              variant="bordered"
              onValueChange={(val) => {
                const updatedAccordions = [...accordions];
                if (
                  !updatedAccordions[index].accordionsLocalized.find(
                    (a) => a.language === language,
                  )
                ) {
                  updatedAccordions[index].accordionsLocalized.push({
                    language,
                    title: "",
                    body: val,
                  });
                } else {
                  updatedAccordions[index].accordionsLocalized =
                    updatedAccordions[index].accordionsLocalized.map(
                      (accordion) => {
                        if (accordion.language === language) {
                          return { ...accordion, body: val };
                        }
                        return accordion;
                      },
                    );
                }
                setAccordions(updatedAccordions);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
